import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/builders/Layout";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import DocumentUpload from "../../layout/builders/Documentupload..jsx";

const DocumentUploadReq = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get project ID from URL

  // *** Ensure this navigates back to live projects ***
  const handleBack = () => {
    navigate("/builder/liveproject"); // Navigate back to the live projects list
  };

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        <div>
          <ProjectBanner
            title={`Upload Completion Documents for Project ${id}`}
            imageUrl="https://via.placeholder.com/1200x300"
          />
        </div>
        {/* Pass the CORRECT handleBack function */}
        <DocumentUpload projectId={id} onBack={handleBack} />
      </Layout>
    </div>
  );
};

export default DocumentUploadReq;